export default __webpack_public_path__ + "786374e085e9a3dd3005adb04397c1e4.svg";